<template>
  <SuppliersTable
    v-if="suppliers.length > 0"
    class="mb-4 pb-10"
    :suppliers="suppliers"
    :is-loading="false"
    style="overflow: scroll; min-height: 250px"
  />
  <p v-else class="text-center mt-10 mb-6">You have not added any suppliers.</p>
  <v-row>
    <v-col>
      <PTextButton
        v-if="!showInputFields"
        appkit-icon="icon-plus-fill"
        variant="text"
        @click="showInputFields = true"
      >
        Add new
      </PTextButton>
    </v-col>
  </v-row>
  <PModalBox
    :open-dialog="showInputFields"
    header="Add supplier"
    size="small"
    @close-dialog="showInputFields = false"
  >
    <template #content>
      <InputSingleSupplier
        :can-upload-business-partner="
          authenticationStore.canUploadBusinessPartners()
        "
        @change="onAddedSupplier"
      />
    </template>
  </PModalBox>
</template>

<script setup lang="ts">
import InputSingleSupplier from "@/views/supplier-registry/InputSingleSupplier.vue";
import SuppliersTable from "@/views/supplier-registry/SuppliersTable.vue";
import { useSenderStore } from "@/stores/sender";
import { useAuthenticationStore } from "@/stores/authentication";
import { useSnackBarStore } from "@/stores/snackBarStore";
import { useSuppliersStore } from "@/stores/suppliersStore";
import { computed, onBeforeMount, ref } from "vue";
import PTextButton from "@/components/custom/buttons/PTextButton.vue";
import PModalBox from "@/components/custom/PModalBox.vue";

const senderStore = useSenderStore();
const authenticationStore = useAuthenticationStore();
const suppliersStore = useSuppliersStore();
const snackBarStore = useSnackBarStore();
const suppliers = computed(() => suppliersStore.suppliers);
const showInputFields = ref(false);

onBeforeMount(async () => {
  senderStore.canSendToBP = authenticationStore.canUploadBusinessPartners();
});

async function onAddedSupplier() {
  showInputFields.value = false;
  await getUpdatedSupplierList();
}

async function getUpdatedSupplierList() {
  try {
    await suppliersStore.setSupplierList();
  } catch (error: any) {
    snackBarStore.showError(error.message);
  }
}
</script>
